import { render, staticRenderFns } from "./addStockholder.vue?vue&type=template&id=4646e56e&scoped=true&"
import script from "./addStockholder.vue?vue&type=script&lang=js&"
export * from "./addStockholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4646e56e",
  null
  
)

export default component.exports